import { render } from "./EditForm.vue?vue&type=template&id=254af258&ts=true"
import script from "./EditForm.vue?vue&type=script&lang=ts"
export * from "./EditForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__